import { ReactNode, useMemo } from 'react';

import { PStyled } from 'approot/shared/styles/typography.style';

type Props = {
  vocabulary: string[] | null;
  note?: ReactNode;
};

const LessonVocabularyView = ({ vocabulary, note }: Props) => {
  const commaSeparatedVocabulary = useMemo(
    () => vocabulary?.slice(0).join(', '),
    [vocabulary]
  );

  if (!vocabulary?.length) return null;

  return (
    <>
      {note}
      <PStyled data-selector="vocab">{commaSeparatedVocabulary}</PStyled>
    </>
  );
};

export default LessonVocabularyView;
